var map = {
	"./audio_5_1a.mp3": 1377,
	"./audio_5_1b.mp3": 1378,
	"./audio_5_1c.mp3": 1379,
	"./audio_5_1d.mp3": 1380,
	"./audio_5_1e.mp3": 1381,
	"./audio_5_2a.mp3": 1382,
	"./audio_5_2b.mp3": 1383,
	"./audio_5_2c.mp3": 1384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1376;